export default Object.freeze({
    IGNORE_REGION_REDIRECT: 'ignoreRegionRedirect',
    REDIRECT_TO_REGION: 'redirectToRegion',
    USER_TODAY_LOGIN_COUNTER: 'userTodayLoginCounter',
});
